import { StateCreator } from "zustand"

import type * as StoreTypes from "@src/types/store"
import { ChatMessage } from "@src/types"

const initState = {
  chatMessages: [],
}

export const createChatMessagesSlice: StateCreator<
  StoreTypes.StoreState,
  [],
  [],
  StoreTypes.ChatMessagesSlice
> = (set) => ({
  ...initState,
  addChatMessage: (message: ChatMessage) => {
    set((state) => ({
      chatMessages: [...state.chatMessages, message],
    }))
  },
  clearChatMessages: (legacyId: string) => {
    set((state) => ({
      chatMessages: state.chatMessages.filter((message) => message.legacyId !== legacyId),
    }))
  },
  resetChatMessages: () => {
    set({ ...initState })
  },
})
